import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  RevokeFreebetsFormContext,
  RevokeFreebetsFormState,
  revokeFreebetsFormStateDefault,
  revokeFreebetsSchemaDefault,
} from '@Forms/freebets/RevokeFreebetsFormContext';

export const RevokeFreebetsFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<RevokeFreebetsFormState>>>(
    revokeFreebetsSchemaDefault
  );
  const methods = useForm({
    defaultValues: revokeFreebetsFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <RevokeFreebetsFormContext.Provider value={value}>
      {children}
    </RevokeFreebetsFormContext.Provider>
  );
};
